import React from "react";

function Connect() {
  return (
    <div>
      <div
        style={{
          minHeight: "55vh",
          position: "relative",
          top: "170px",
        }}
        className="connect"
      >
        <center>
          <h1 style={{ color: "white", fontSize: "15px", padding: "10px" }}>
            Let Us Connect!
          </h1>
          <div style={{}}>
            <b>
              <a
                href="https://twitter.com/@KAYODE__"
                className=""
                style={{ width: "50%" }}
              >
                <span>
                  <i
                    className="fab fab-twitter"
                    style={{
                      color: "white",
                      fontSize: "25px",
                      position: "relative",
                      right: "50px",
                    }}
                  >
                    twitter
                  </i>
                </span>
              </a>
            </b>
            <a
              href="https://wa.me/+2349026524611"
              className=""
              style={{ width: "50%" }}
            >
              <span>
                <i
                  className="fab fab-whatsapp"
                  style={{
                    color: "white",
                    fontSize: "25px",
                    position: "relative",
                    left: "50px",
                  }}
                >
                  whatsapp
                </i>
              </span>
            </a>
          </div>
          <br />
          <div>
            <a
              href="mailto:adetunjitosin21@gmail.com"
              className="btn btn-primary"
              style={{
                width: "60%",
                padding: "",
                height: "",
                fontWeight: "bolder",
                fontSize: "15px",
                fontFamily: "sans-serif",
              }}
            >
              Email
              <span>
                <i
                  className="fa fa-envelope"
                  style={{
                    color: "white",
                    fontSize: "20px",
                    position: "relative",
                    left: "10px",
                  }}
                ></i>
              </span>
            </a>
            <br />
            <br />
            {/*  */}
            <a
              href="tel:+2349026524611"
              className="btn btn-secondary"
              style={{
                width: "60%",
                padding: "",
                height: "",
                fontSize: "15px",
                fontFamily: "sans-serif",
              }}
            >
              Put a call through
              <span>
                <i
                  className="fa fa-phone"
                  style={{
                    color: "white",
                    fontSize: "20px",
                    position: "relative",
                    left: "10px",
                  }}
                ></i>
              </span>
            </a>
          </div>
        </center>
      </div>
    </div>
  );
}

export default Connect;
